<template>
    <div class="bg-white">
        <div class="container-fluid print-bg d-flex justify-content-center align-items-center text-center" style="min-height: max(14vw, 150px); background-size: max(100vw, 958px);">
            <h2 class="h2-bigest text-uppercase" v-html="store.steps[store.currentStep].header"></h2>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../js/store";

export default {
    setup() {
        const store = useFlexiblePackagingStore();

        return {
            store: store,
        }
    },
}
</script>

<style lang="scss" scoped>
    ::v-deep b {
        font-weight: 800 !important;
    }
</style>
